import { Trans, useTranslation } from "react-i18next";
import { UserSubscription } from "./types";
import { paymentSymbol } from "./utils";
import { formatDate } from "../../utils/DateUtils";
import "./styles.scss";

interface Props {
    subscription: UserSubscription;
    timezone?: string;
}

export default function CurrentPlanCard({ subscription, timezone }: Props) {
    const { t } = useTranslation();
    const isAutoRenew =
        subscription.status === "active" && subscription.auto_renew;

    return (
        <div className="current-subscription">
            <div className="d-flex justify-content-between align-items-center subscription-plan">
                <p className="mb-0" style={{ fontWeight: "500" }}>
                    {t(subscription?.payment_plan?.name)}
                </p>
                <p className="mb-0" style={{ fontWeight: "500" }}>
                    {paymentSymbol[subscription.currency]}
                    {subscription.amount}
                </p>
            </div>
            <div>
                <div>
                    <Trans
                        i18nKey={
                            isAutoRenew
                                ? "subscriptions.next_billing_data"
                                : "subscriptions.plan_expire_on"
                        }
                        values={{
                            date: formatDate(
                                subscription.ends_at,
                                "MMMM DD, YYYY",
                                timezone
                            ),
                        }}
                        components={{ strong: <strong /> }}
                    />
                </div>
            </div>
        </div>
    );
}
